"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestGiverQuests = void 0;
const NPC_1 = require("../classes/NPC");
const Quest_1 = require("../classes/Quest");
const QuestState_1 = require("../types/QuestState");
const definables_1 = require("definables");
const getQuestState_1 = require("./getQuestState");
const getQuestGiverQuests = (npcID) => {
    const npc = (0, definables_1.getDefinable)(NPC_1.NPC, npcID);
    return npc.questGiver.quests.filter((questGiverQuest) => {
        const quest = (0, definables_1.getDefinable)(Quest_1.Quest, questGiverQuest.questID);
        if (quest.hasPrerequisiteQuest()) {
            if ((0, getQuestState_1.getQuestState)(quest.prerequisiteQuestID) !== QuestState_1.QuestState.Complete) {
                return false;
            }
        }
        return true;
    });
};
exports.getQuestGiverQuests = getQuestGiverQuests;
